import './styles.sass';

import React from 'react';
import Transition from 'components/Explorer/Transition';
import { Link } from 'react-router-dom';

import Gauge from 'components/Explorer/Gauge';
import TopItemList from 'components/Highlights/TopItemList';
import NumberHelper from 'util/number_helper';
import * as QueryParams from 'components/Explorer/models/query_params';
import useExplorerData, { Loading } from 'hooks/useExplorerData';
import useQueryParams from 'hooks/useQueryParams';

const COLORS = ['#F418FF', '#B712BF', '#7A0C7F'];

const linkForAffiliation = (params, affiliation) => {
  const filters = { ...(params.filters || {}), 'affiliations[]': [affiliation.id] };
  return QueryParams.locationFor(QueryParams.withFilters(params, filters), '/mentions');
};

const trackJumpLink = () => {
  Analytics.trackEvent('highlights-click-jump-link', { jumpedTo: 'top-affiliations' });
};

const TopAffiliations = () => {
  const params = useQueryParams();
  const { data, loading } = useExplorerData('highlights/top_affiliations', params, { reloadOn: ['filters'] });

  const isLoading = loading === Loading.NOT_STARTED || loading === Loading.IN_PROGRESS;
  const hasResults = Array.isArray(data) && data.length > 0;

  const affiliationRank = (affiliation, index) => (
    <TopItemList.Item key={affiliation.id}>
      <Gauge percentage={affiliation.ratio} color={COLORS[index % COLORS.length]} />
      <div className="description">
        <div className="title">
          <Link to={linkForAffiliation(params, affiliation)}>{affiliation.name}</Link>
        </div>
        <div className="meta">
          {I18n.htmlSafe('Explorer.Highlights.TopAffiliations.meta.mentions', {
            count: affiliation.mentions,
            formattedCount: NumberHelper.formatStatistic(affiliation.mentions)
          })}
          <span>&nbsp;</span>
          {I18n.htmlSafe('Explorer.Highlights.TopAffiliations.meta.outputs', {
            count: affiliation.outputs,
            formattedCount: NumberHelper.formatStatistic(affiliation.outputs)
          })}
        </div>
      </div>
    </TopItemList.Item>
  );

  const content = () => {
    if (loading === Loading.ERROR) {
      return <div className="Highlights-error-message">{I18n.t('Explorer.loading_error')}</div>;
    }
    return (
      <div key="content" className="Highlights-content Highlights-TopAffiliations-content">
        {hasResults ? (
          <TopItemList>{data.map(affiliationRank)}</TopItemList>
        ) : (
          <div className="Highlights-content-empty-message">{I18n.t('Explorer.Highlights.TopAffiliations.empty')}</div>
        )}
      </div>
    );
  };

  return (
    <div className="Highlights-TopAffiliations Highlights-block">
      <h2 className="Highlights-title">{I18n.t('Explorer.Highlights.TopAffiliations.title')}</h2>
      <div className="Highlights-content-wrapper">
        <Transition>
          {isLoading ? <div key="loadingMessage" className="Highlights-loading-message" /> : content()}
        </Transition>
        {hasResults && (
          <Link
            onClick={trackJumpLink}
            to={QueryParams.locationFor(params, '/mentions')}
            className="Highlights-jump-link"
          >
            {I18n.t('Explorer.Highlights.TopAffiliations.more')}
          </Link>
        )}
      </div>
    </div>
  );
};

export default TopAffiliations;
